import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  warningMessage: {
    color: 'red',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 3,
  },

}))
